module.exports = __webpack_public_path__ + "img/tcys.794fbbf1.png";